
function swatchClick(index, sku, id, avail) {
  var position = document.querySelector(`.swatch_${sku}`).getAttribute('swatch');
  console.log("position>>>", position)
  document.querySelectorAll('.swatch').forEach((swatch) => {
    swatch.classList.remove('borderClass');
  });
  document.querySelector(`.swatch_${sku}`).classList.add('borderClass');
  document.querySelectorAll(`.buyProduct_${position}`).forEach((buyProduct) => {
    buyProduct.setAttribute('attr', id);
    // buyProduct.querySelector('.ProductForm__AddToCart').setAttribute('data-product-id', id);
    // buyProduct.querySelector('.collection_atc').querySelector('input[name=id]').setAttribute('value', id);
  })
  document.querySelector('.tabs_content').classList.add('productView');
  if (window.innerWidth > 320) {
    document.querySelectorAll(`.buyProduct_${position}`).forEach((buyProduct) => {
      buyProduct.style.display = "block";
    });
  }
  else {
    document.querySelector('.mobAtc').style.display = "block";
    if (avail == 'false') {
      document.querySelector('.mobAtc').setAttribute('disabled', 'disabled');
      document.querySelector('.mobAtc').innerHTML = 'Sold Out';
    }
    else {
      document.querySelector('.mobAtc').setAttribute('btn', id);
      document.querySelector('.mobAtc').removeAttribute('disabled');
    }

  }
  window.YMK.applyMakeupBySku(sku);
  
}
function slickInitialize(classobj, counts, mobcounts) {
  if (window.innerWidth > 648) {
    $(classobj).slick({ slidesToShow: counts, arrows: true });
  }
  else {
    $(classobj).slick({ slidesToShow: mobcounts, arrows: true });
  }
}

window.addEventListener('load', () => {
  class MakeupPro extends HTMLElement {
    constructor() {
      super();
      const mobBtn = this.querySelector(".mobAtc");
      mobBtn.addEventListener("click", this.atc.bind(this));
    }
    connectedCallback() {
      YMK.open(true, false, false)
      slickInitialize('.productsContent', 4, 2);
      document.querySelectorAll('.tabsTitle').forEach(tab => {
        tab.addEventListener('click', () => {
          this.unSlick();
          this.showTabContent(tab);
          document.querySelector('.mobAtc').style.display = "none";
        });
      });
      document.querySelectorAll('.catBlock').forEach((category) => {
        category.addEventListener('click', () => {
          this.unSlick();
          this.showCatContent(category);
          document.querySelector('.mobAtc').style.display = "none";
        })
      })
      // document.querySelectorAll('.produt_card').forEach(product => {
      //   product.addEventListener('click', () => {
      //     alert();
      //     this.unSlick();
      //     this.showSwatch(product);
      //     document.querySelector('.mobAtc').style.display = "none";
      //   });
      // });
      var this__ = this;
      // $('.produt_card').each(function(product){
        
      // })
      $('body').on('click','.produt_card',function(e){
        console.log("e>>>>",e.currentTarget)
          this__.unSlick();
          this__.showSwatch(e.currentTarget);
          document.querySelector('.mobAtc').style.display = "none";
      })

      document.querySelector('.editProduct').addEventListener('click', () => {
        document.querySelector('.mobAtc').style.display = "none";
        document.querySelector('.tabs_content').classList.remove('productView');
        // });
        const position = document.querySelector('.editProduct').getAttribute('position');
        // console.log("position3>>>", position)
        console.log("document.querySelector('.editProduct').closest('.activeTab')>>", document.querySelector('.editProduct').closest('.tabs_content'));
        var productContent = document.querySelector('.editProduct').closest('.tabs_content').querySelector('.activeTab').querySelectorAll('.produt_card') || document.querySelector('.editProduct').closest('.tabs_content').querySelector('.activeTab').querySelector(`.productsContent_${position}`).querySelectorAll('.produt_card');
        productContent.forEach((product) => {
          product.classList.add('activeProduct');
        })
        document.querySelectorAll('.buyProduct').forEach((product) => {
          product.style.display = 'none';
        })
        document.querySelectorAll('.SwatchContent').forEach((swatch) => {
          swatch.classList.remove('activeCat');
        });
        if (position != null) {
          document.querySelectorAll(`.edit_${position}`).forEach((editCat) => {
            editCat.classList.add('activeCat');
          });
        }
        slickInitialize('.productsContent', 4, 2);
      })
      // })

      document.querySelectorAll('.CatEdit').forEach((catEdit) => {
        catEdit.addEventListener('click', () => {
          // this.destroySlick('.catimages');
          // document.querySelectorAll('.catimages').forEach((category)=>{
          //   this.destroySlick(category);
          // })
          if ($('.catimages').hasClass('slick-initialized')) {
            document.querySelectorAll('.catimages').forEach((category) => {
              this.destroySlick(category);
            })
          }
          document.querySelector('.mobAtc').style.display = "none";
          document.querySelectorAll('.productsContent').forEach((product) => {
            product.classList.remove('activeCat');
          })
          document.querySelectorAll('.categoryContent').forEach((cat) => {
            cat.style.display = "block";
          });
          document.querySelectorAll('.catBlock').forEach((product) => {
            product.classList.add('activeCat');
          })
          document.querySelectorAll('.CatgeoryEdit').forEach((product) => {
            product.classList.remove('activeCat');
          })
          document.querySelectorAll('.catimages').forEach((catimage) => {
            catimage.classList.add('activeCat');
          });
        });
      });

    }

    atc(e) {
      const attr = e.target.getAttribute("btn");
      const button = document.querySelector(`[data-product-id="${attr}"]`);
      console.log("button>>>", button)
      if (button) {
        button.click();
      }
    }
    destroySlick(selector) {
      $(selector).slick("unslick");
    }
    showTabContent(tab) {

      const position = tab.getAttribute('position');
      document.querySelectorAll('.tabsTitle').forEach(content => {
        content.classList.remove('underline');
      });
      tab.classList.add('underline');
      document.querySelectorAll('.tabsContent').forEach(content => {
        content.classList.remove('activeTab');
        // content.classList.remove('productView');
      });
      document.querySelector('.tabs_content').classList.remove('productView');
      document.querySelector(`.tabsContent.${position}`).classList.add('activeTab');
      document.querySelector('.SwatchContent').classList.remove('activeCat');
      document.querySelectorAll('.categoryContent').forEach((content) => {
        content.style.display = "block";
      });
      document.querySelectorAll('.productsContent').forEach((product) => {
        product.classList.remove('activeCat');
      })
      document.querySelectorAll('.catBlock').forEach((product) => {
        product.classList.add('activeCat');
      })
      document.querySelectorAll('.CatgeoryEdit').forEach((product) => {
        product.classList.remove('activeCat');
      })
      if (document.querySelectorAll('.catimages')) {
        //   this.destroySlick('.catimages');
        if ($('.catimages').hasClass('slick-initialized')) {
          document.querySelectorAll('.catimages').forEach((category) => {
            this.destroySlick(category);
          })
        }
      }

      document.querySelectorAll('.catimages').forEach((cat) => {
        cat.classList.add('activeCat');
      });
      slickInitialize('.productsContent', 4, 2);
      slickInitialize('.catimages', 3, 2);
    }
    showCatContent(category) {
      // this.destroySlick('.productsContent');

      const position = category.getAttribute('position');
      const catname = category.getAttribute('catname');
      const tabsTitle = category.getAttribute('tabsTitle')
      const catBlock = document.querySelectorAll('.catBlock');
      document.querySelectorAll('.categoryContent').forEach((content) => {
        content.style.display = "none";
      });
      document.querySelectorAll(`.edit_${position}`).forEach((edit) => {
        edit.classList.add('activeCat');
      });
      document.querySelectorAll('.internalCat .name').forEach((name) => {
        name.innerHTML = catname;
      });
      catBlock.forEach((block) => {
        block.classList.remove('activeCat');
      });
      // document.querySelectorAll('.tabsContent').forEach((tab) => {
      //   tab.classList.remove('productView');
      // });
      document.querySelector('.tabs_content').classList.remove('productView');
      document.querySelectorAll(`.productsContent_${position}`).forEach((content) => {
        content.classList.add('activeCat');
      });
      slickInitialize('.productsContent', 4, 2);
    }
    showSwatch(product) {
      if ($('.swatchesBox').hasClass('slick-initialized')) {
        console.log("workstrue")
        // document.querySelectorAll('.catimages').forEach((category)=>{
        this.destroySlick('.swatchesBox');
        // })
      }
      var productVariantsData = '';
      var handle = product.getAttribute('productHandle');
      var position = product.getAttribute('attr');
      console.log(" product.closest('.productsContent')>>>", $(product).parents('.productsContent'))
      var newPos = $(product).parents('.productsContent').attr('attr');
      if (newPos) {
        document.querySelector('.editProduct').setAttribute('position', newPos);
        // });
      }
      const productCard = document.querySelectorAll('.produt_card');
      productCard.forEach((product) => {
        product.classList.remove('activeProduct');
      })
      document.querySelector('.tabs_content').classList.remove('productView');
      // document.querySelectorAll('.tabsContent').forEach((tab) => {
      //   tab.classList.remove('productView');
      // });
      document.querySelector('.SwatchContent').classList.add('activeCat');
      document.querySelectorAll('.CatgeoryEdit').forEach((cat) => {
        cat.classList.remove('activeCat');
      });
      document.querySelectorAll('.categoryContent').forEach((cat) => {
        cat.style.display = "none";
      });
      fetch(`/products/${handle}?view=swatch`).then((response) => response.text())
        .then((response) => {
          var newResponse = new DOMParser().parseFromString(response, 'text/html');
          newResponse.querySelectorAll('.swatch').forEach((swatch) => {
            // console.log("swatch>>>",swatch)
            swatch.setAttribute('swatch', position);
          })
          document.querySelector('.EditproductTitle').innerHTML = newResponse.querySelector('.prodTitle').innerHTML;
          var variantsData = newResponse.querySelector('.swatchContent').innerHTML;
          document.querySelector('.swatchesBox').innerHTML = variantsData;

          setTimeout(function () {
            console.log("timeoutSur");
            slickInitialize('.swatchesBox', 7, 4);
          }, 1e3);

        });
    }
    unSlick() {
      document.querySelectorAll('.productsContent').forEach((product) => {
        this.destroySlick(product);
      })

    }
  }
  customElements.define('makeup-pro', MakeupPro);
});

